import React from "react";
import { Helmet } from "react-helmet";

const ProfileSEO = () => {
  return (
 
       <Helmet>
         {/* Page title optimized for the profile page */}
         <title>Betpro Plus Profile - Manage Your Account</title>
 
         <link rel="icon" href="https://betprowallet.pk/favicon.ico" />
 
         {/* Canonical tag */}
         <link rel="canonical" href="https://betprowallet.pk/profile" />
 
         {/* Meta description focusing on managing user profiles */}
         <meta name="description" content="Manage your Betpro Plus profile and account settings. ⚽️ Update your personal information, check your balance, track your bets, and manage withdrawals. Secure and easy profile management at Betprowallet.pk." />
 
         {/* Meta keywords for search engine optimization */}
         <meta name="keywords" content="Betpro Plus profile, manage Betpro Plus account, Betpro Plus personal information, check balance, track bets, Betpro Plus withdrawals, Betprowallet.pk profile" />
 
         {/* Meta author */}
         <meta name="author" content="Betpro Plus" />
 
         {/* Open Graph meta tags for social media sharing */}
         <meta property="og:title" content="Betpro Plus Profile - Manage Your Account" />
         <meta property="og:description" content="Access and manage your Betpro Plus profile. Update personal information, view your betting history, check your account balance, and manage your withdrawals." />
         <meta property="og:url" content="https://betprowallet.pk/profile" />
         <meta property="og:type" content="website" />
         <meta property="og:image" content="https://betprowallet.pk/bpthumb1.jpg" />
 
         {/* Twitter Card for sharing on Twitter */}
         <meta name="twitter:card" content="summary_large_image" />
         <meta name="twitter:title" content="Betpro Plus Profile - Manage Your Account" />
         <meta name="twitter:description" content="Manage your Betpro Plus account and update your profile information. Track your bets, check your balance, and manage your withdrawals at Betprowallet.pk." />
         <meta name="twitter:image" content="https://betprowallet.pk/bpthumb1.jpg" />
 
         {/* Structured Data for SEO */}
         <script type="application/ld+json">
           {`
       {
         "@context": "https://schema.org",
         "@type": "WebPage",
         "name": "Betpro Plus Profile - Manage Your Account",
         "url": "https://betprowallet.pk/profile",
         "description": "Manage your Betpro Plus profile and account. Update personal details, check balance, track bets, and manage withdrawals securely on Betpro Plus.",
         "publisher": {
           "@type": "Organization",
           "name": "Betpro Plus"
         }
       }
     `}
         </script>
       </Helmet>
 
  );
};

export default ProfileSEO;
